export const PHONE_MEDIA_QUERY = '(max-width: 640px)';
export const IS_IE11 = (!!window.MSInputMethodContext && !!document.documentMode);
export const IS_ON_PHONE = window.matchMedia ? window.matchMedia(PHONE_MEDIA_QUERY).matches : false;
